<script>
  import Button from '@/components/ui/Button.svelte';
  import { router } from '@inertiajs/svelte'

  let { category = null, parent_categories = [], all_boards = [], selected_board_ids = [], flash = {} } = $props()
  // svelte-ignore state_referenced_locally
  const initialCategory = category
  // svelte-ignore state_referenced_locally
  const initialBoardIds = selected_board_ids || []

  let form = $state({
    name: initialCategory?.name || '',
    slug: initialCategory?.slug || '',
    description: initialCategory?.description || '',
    color: initialCategory?.color || '',
    parent_id: initialCategory?.parent_id || '',
    position: initialCategory?.position ?? 0,
    board_ids: initialBoardIds
  })

  let isEdit = $derived(!!category?.id)
  let isSubmitting = $state(false)

  function autoSlug() {
    if (!isEdit && form.name && !form.slug) {
      form.slug = form.name
        .toLowerCase()
        .replace(/[가-힣]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '')
    }
  }

  function toggleBoard(boardId) {
    const idx = form.board_ids.indexOf(boardId)
    if (idx >= 0) {
      form.board_ids = form.board_ids.filter(id => id !== boardId)
    } else {
      form.board_ids = [...form.board_ids, boardId]
    }
  }

  function handleSubmit() {
    isSubmitting = true

    const data = { ...form }
    if (!data.parent_id) data.parent_id = null
    if (!data.color) data.color = null

    const options = {
      onFinish: () => {
        isSubmitting = false
      }
    }

    if (isEdit) {
      router.patch(`/admin/categories/${category.id}`, { category: data }, options)
    } else {
      router.post('/admin/categories', { category: data }, options)
    }
  }

  const presetColors = ['#EF4444', '#F59E0B', '#10B981', '#3B82F6', '#8B5CF6', '#EC4899', '#6B7280', '#14B8A6']
</script>

<!-- Breadcrumb -->
  <div class="flex items-center gap-2 text-caption text-content-tertiary mb-6">
    <a href="/admin" class="hover:text-primary transition-colors">관리자</a>
    <span>/</span>
    <a href="/admin/categories" class="hover:text-primary transition-colors">카테고리</a>
    <span>/</span>
    <span class="text-content">{isEdit ? '수정' : '새 카테고리'}</span>
  </div>

  <main class="max-w-2xl">
    {#if flash.alert}
      <div class="mb-6 p-4 bg-error-light dark:bg-error/20 border border-error/30 rounded-xl text-error-dark dark:text-error text-body2">
        {flash.alert}
      </div>
    {/if}

    <h2 class="text-h1 text-content mb-6">{isEdit ? '카테고리 수정' : '새 카테고리 생성'}</h2>

    <form onsubmit={(e) => { e.preventDefault(); handleSubmit(); }} class="card card-bordered p-6 shadow-md space-y-6">
      <!-- 카테고리명 -->
      <div>
        <label for="name" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">카테고리명 *</label>
        <input
          id="name"
          type="text"
          bind:value={form.name}
          oninput={autoSlug}
          required
          placeholder="예: 취업/이직"
          class="input w-full py-2.5"
        />
      </div>

      <!-- 슬러그 -->
      <div>
        <label for="slug" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">슬러그 *</label>
        <input
          id="slug"
          type="text"
          bind:value={form.slug}
          required
          placeholder="예: career"
          class="input w-full py-2.5"
        />
        <p class="text-caption text-content-tertiary mt-1">영문 소문자, 숫자, 하이픈만 허용</p>
      </div>

      <!-- 설명 -->
      <div>
        <label for="description" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">설명</label>
        <textarea
          id="description"
          bind:value={form.description}
          placeholder="카테고리 설명..."
          rows="3"
          class="input w-full py-2.5"
        ></textarea>
      </div>

      <!-- 상위 카테고리 -->
      <div>
        <label for="parent_id" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">상위 카테고리</label>
        <select id="parent_id" bind:value={form.parent_id} class="select w-full">
          <option value="">없음 (루트 카테고리)</option>
          {#each parent_categories as parent}
            <option value={parent.id}>{parent.name}</option>
          {/each}
        </select>
      </div>

      <!-- 색상 -->
      <div>
        <div class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">색상</div>
        <div class="flex items-center gap-3">
          <div class="flex items-center gap-2">
            {#each presetColors as color}
              <button
                type="button"
                onclick={() => form.color = color}
                class="w-8 h-8 rounded-full border-2 transition-transform hover:scale-110
                  {form.color === color ? 'border-gray-900 dark:border-white scale-110' : 'border-transparent'}"
                style="background-color: {color}"
                aria-label={`${color} 색상 선택`}
              ></button>
            {/each}
          </div>
          <input
            type="text"
            bind:value={form.color}
            placeholder="#000000"
            class="input w-28 py-1.5 text-body2"
          />
          {#if form.color}
            <button type="button" onclick={() => form.color = ''} class="text-caption text-gray-500 hover:text-error">초기화</button>
          {/if}
        </div>
      </div>

      <!-- 순서 -->
      <div>
        <label for="position" class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">정렬 순서</label>
        <input
          id="position"
          type="number"
          bind:value={form.position}
          class="input w-full py-2.5"
        />
      </div>

      <!-- 게시판 연결 -->
      {#if all_boards.length > 0}
        <div>
          <div class="block text-label text-gray-700 dark:text-dark-text-medium mb-2">게시판 연결</div>
          <div class="flex flex-wrap gap-2">
            {#each all_boards as board}
              <button
                type="button"
                onclick={() => toggleBoard(board.id)}
                class="px-3 py-1.5 rounded-lg text-body2 border transition-colors
                  {form.board_ids.includes(board.id)
                    ? 'bg-primary text-white border-primary'
                    : 'bg-surface text-content-secondary border-gray-300 dark:border-dark-border hover:border-primary'
                  }"
              >{board.name}</button>
            {/each}
          </div>
        </div>
      {/if}

      <!-- Submit -->
      <div class="flex items-center justify-end gap-3 pt-4 border-t border-default">
        <a href="/admin/categories" class="btn btn-secondary btn-md">취소</a>
        <Button type="submit" size="md" loading={isSubmitting} loadingLabel={isEdit ? '수정 중...' : '생성 중...'} disabled={!form.name || !form.slug}>
          {isEdit ? '수정' : '생성'}
        </Button>
      </div>
    </form>
  </main>
